import React from "react";

import CompareLog from "~/pages/Logs/components/LogView/CompareLog";
import DefaultLog from "~/pages/Logs/components/LogView/DefaultLog";

export enum LOG_RESOLVE_REASON {
  compare = "compare",
}

export const logFieldResolver = (
  logInstance: { [key: string]: unknown },
  event?: string,
  resolveBy?: LOG_RESOLVE_REASON,
) => {
  return Object.keys(logInstance).map((logInstanceKey, index) => {
    if (resolveBy === LOG_RESOLVE_REASON.compare) {
      return (
        <CompareLog
          key={logInstanceKey + index}
          logInstance={logInstance}
          filedKey={logInstanceKey}
          event={event}
        />
      );
    }
    if (typeof logInstance[logInstanceKey] !== "object") {
      return (
        <DefaultLog
          key={logInstanceKey + index}
          logInstance={logInstance}
          filedKey={logInstanceKey}
        />
      );
    }
    if (Array.isArray(logInstance[logInstanceKey])) {
      console.log(logInstance[logInstanceKey]);
    }
  });
};
